import { ChangeDetectionStrategy, Component, input, model, OnChanges, SimpleChanges } from '@angular/core';
import { SkeletonLoaderComponent } from '../../../../shared/components/skeleton-loader/skeleton-loader.component';
import { AlpitranslatePipe } from '../../../../core/pipes/alpitranslate.pipe';
import {
  IconComponent,
  boots,
  funEquip,
  helmet,
  nordic,
  provideIcons,
  ski,
  snowboard
} from '../../../../shared/icons';
import { ProductCategory } from '../../services/entities';

@Component({
  selector: 'app-product-list-categories',
  templateUrl: './product-list-categories.component.html',
  styleUrls: ['./product-list-categories.component.scss'],
  imports: [AlpitranslatePipe, IconComponent, SkeletonLoaderComponent],
  providers: [
    provideIcons({
      ski,
      boots,
      snowboard,
      funEquip,
      nordic,
      helmet
    })
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListCategoriesComponent implements OnChanges {
  shopCategories = input.required<ProductCategory[]>();
  selectedCategory = model.required<ProductCategory>();
  readonly categoriesPriority = [ProductCategory.Ski, ProductCategory.Snowboard, ProductCategory.Nordic];

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['shopCategories'] &&
      this.shopCategories() &&
      !this.shopCategories().includes(this.selectedCategory())
    ) {
      const newCategory =
        this.categoriesPriority.find(category => this.shopCategories().includes(category)) ||
        this.shopCategories()[0];
      this.switchCategory(newCategory);
    }
  }

  switchCategory(category: ProductCategory) {
    this.selectedCategory.set(category);
  }
}
